// extracted by mini-css-extract-plugin
var _1 = "modalReport-module_agreement__fW4thm";
var _2 = "modalReport-module_dialogActions__jng3MO";
var _3 = "modalReport-module_dialogContnent__sCYA99";
var _4 = "modalReport-module_dialog_paper__YW5cHw";
var _5 = "modalReport-module_input__E5mkVp";
var _6 = "modalReport-module_notificationCheckbox__LWK7O4";
export { _1 as "agreement", _2 as "dialogActions", _3 as "dialogContnent", _4 as "dialog_paper", _5 as "input", _6 as "notificationCheckbox" }
